/**
 * Reading the entitlement list the server sent with the session.
 *
 * The UI uses this to **hide** what it cannot use; the server refuses the same
 * features independently. A hidden button is not a control (docs/05 §3), so this
 * helper is a rendering concern only: no module that decides money behaviour may
 * import it.
 *
 * `core.trading` is treated as always present, matching the fail-safe matrix:
 * even an unlicensed tenant gets its feature list, and trading is not in it to
 * take away.
 */

export function hasFeature(
  features: readonly string[] | null | undefined,
  feature: string,
): boolean {
  if (feature === 'core.trading') return true;
  return (features ?? []).includes(feature);
}

/** Does this session carry the `admin.app` entitlement? */
export function canUseAdminConsole(features: readonly string[] | null | undefined): boolean {
  return hasFeature(features, 'admin.app');
}

/** Does this session carry the `manager.app` entitlement? */
export function canUseManagerConsole(features: readonly string[] | null | undefined): boolean {
  return hasFeature(features, 'manager.app');
}
